import { getType } from 'typesafe-actions'

import _ from 'lodash'

import { all, call, put, takeLatest } from 'redux-saga/effects'

import { AxiosResponse } from 'axios'

import { withLoading } from '../loading'
import { apiCall } from '../../utils/api'

import { waitForConfigLoad } from '../../utils/sagaUtils'

import { SearchProductsResponse, SearchProductResponse, UmbracoProductResponse } from './types'
import { ProductsActions } from './actions'

export function* loadProducts(action: ReturnType<typeof ProductsActions.loadProducts>) {
  yield call(waitForConfigLoad)

  const { domainCode, countryCode, type, allowAccountingSource, productCategory } = action.payload

  const { data: productsData }: AxiosResponse<SearchProductsResponse> = yield call(apiCall, {
    url: '/api/Search/products',
    method: 'get',
    params: { type, domainCode, countryCode, allowAccountingSource, productCategory }
  })

  const productCodes = _.compact(_.map(productsData.products, p => p.code))

  if (_.size(productCodes) === 0) {
    yield put(ProductsActions.setLoadedProducts({ products: [] }))
    return
  }

  const { data: umbracoData }: AxiosResponse<UmbracoProductResponse> = yield call(apiCall, {
    url: '/api/products/products',
    method: 'post',
    data: { productCodes },
    umbracoCall: true
  })

  const products = _.map(
    productsData.products,
    x =>
      <SearchProductResponse>{
        ...x,
        umbracoName: _.find(umbracoData?.data, u => u.bifCode == x.code)?.name || '',
        umbracoPreviewDescription: _.find(umbracoData?.data, u => u.bifCode == x.code)?.previewDescription || ''
      }
  )

  yield put(
    ProductsActions.setLoadedProducts({
      products
    })
  )
}

/* istanbul ignore next */
export function* productsSagas() {
  yield all([takeLatest(getType(ProductsActions.loadProducts), withLoading('products', loadProducts))])
}
